import text from './text.json'
import {Link} from 'react-router-dom'
import {routes} from '../../routes'
import {useSelector} from 'react-redux'
import classNames from 'classnames'

const EmptyIntegration = ({close}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('modal-body no-integration-modal', {
            dark: isDarkMode
        })}>
            <span className="desc">{text.integration_desc}</span>
            <div className="buttons">
                <button className="light-bg cancel-button" onClick={close}>{text.cancel}</button>
                <Link className="simple-blue-button" to={routes.integrations.path}>
                    {text.go_to_integrations}
                </Link>
            </div>
        </div>

    )
}

export default EmptyIntegration
